import {ChangeDetectionStrategy, Component, ViewEncapsulation} from '@angular/core';

import {CommonModule} from '@angular/common';
import { LoaderService } from 'src/app/core/services/loader.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css'],
  standalone: true,
  imports: [
    CommonModule,
  ],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {
  constructor(public loader: LoaderService) {
  }
  loadMessagge(){
    console.log( this.loader.getMessage())
    return this.loader.getMessage()
  }
}
